import React from 'react';

function App() {
	return <div className="App">EventResultPage</div>;
}

export default App;
